<template>
  <div class="container">
    <h1 class="display-4 text-center my-5">Purchase Successful</h1>
    <p class="h4">What next?</p>
    <p>
      Thank you for purchasing a Hostel Hoppers rental pass. Please call us at
      any time on <strong class="orange-text">1800 24 68 69</strong> to reserve
      your vehicle. You now have 90 rental days of any Hostel Hoppers vehicles
      at Campervan Village locations across Australia and New Zealand.
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
